var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as dayjs from 'dayjs';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Table from '@/common/components/Table/oldIndex.vue';
import { refactorCalendars, getPopoverOffset, collectDatesByStartAndEnd, beforeSubmit, refactorSingleClueHandle } from '../../utils';
import DaySection from '@views/schedule/components/Calendar/DaySection.vue';
import DatePopover from '@views/schedule/components/Calendar/DatePopover.vue';
import BoothPopover from '@views/schedule/components/Calendar/BoothPopover.vue';
import Empty from '@views/schedule/components/Calendar/Empty.vue';
import AddClueDialog from './AddClueDialog.vue';
import { dateFns, deepCopy } from '@lhb/func';
import HistoryLine from '@views/schedule/components/Calendar/HistoryLine.vue';
import ElTableInfiniteScroll from 'el-table-infinite-scroll';
// @ts-ignore
var Day = /** @class */ (function (_super) {
    __extends(Day, _super);
    function Day() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.calendars = [];
        _this.lastShopName = '';
        _this.infiniteDisable = true;
        // private tableLoading = this.loading;
        _this.hoverColumnIndex = 0;
        _this.isSelecting = false;
        _this.selected = {
            boothInfo: {
                id: null,
            },
            dates: [],
            sort: null,
            startAt: null,
            endAt: null,
        };
        _this.today = dateFns.changeTime(new Date(), null, true);
        _this.showHistoryLine = false;
        _this.todayOffset = 0;
        _this.tableScrollX = 0;
        _this.curSelectLayout = {
            x: 0,
            y: 0,
            initY: 0,
            scrollY: 0,
        };
        _this.showAddClueDialog = false;
        return _this;
    }
    Object.defineProperty(Day.prototype, "dateType", {
        get: function () {
            var _a = this.searchParams, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate)
                return 15;
            var type = dateFns.diffDayBetween(startDate, endDate) - 1;
            return type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Day.prototype, "currentDates", {
        get: function () {
            var _a = this.searchParams, startDate = _a.startDate, endDate = _a.endDate;
            var dates = [];
            var currentDate = new Date(startDate);
            var endTime = new Date(endDate).getTime();
            for (; currentDate.getTime() <= endTime;) {
                dates.push(dateFns.changeTime(currentDate, null, true));
                currentDate.setDate(currentDate.getDate() + 1);
            }
            return dates;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Day.prototype, "tableColumns", {
        get: function () {
            var _this = this;
            var columns = [{ slotName: 'name', label: '点位名称', minWidth: 80, resizable: false }];
            this.currentDates.forEach(function (date) {
                columns.push({ slotName: date, label: date, minWidth: _this.dateType === 15 ? 40 : 24, customHeader: true, resizable: false });
            });
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    // get tableHeight() {
    //   console.log(this.$refs.table);
    //   console.log(this.$refs.table?.clientHeight);
    //   return 0;
    // }
    Day.prototype.dataChange = function (newVal) {
        var _this = this;
        var _a;
        // this.tableLoading = true;
        var shopName = this.searchParams.offset > 0 ? this.lastShopName : '';
        var calendarData = refactorCalendars({ records: newVal, type: 'day', minDate: this.searchParams.startDate, maxDate: this.searchParams.endDate, shopName: shopName });
        var data = (_a = calendarData === null || calendarData === void 0 ? void 0 : calendarData.data) === null || _a === void 0 ? void 0 : _a.map(function (e) { return (__assign(__assign({}, e), { selectedDates: [] })); });
        if (this.searchParams.offset > 0) {
            this.calendars = __spreadArrays(this.calendars, data);
        }
        else {
            this.calendars = data;
            this.scrollToTop();
        }
        this.lastShopName = calendarData.shopName;
        this.getTodayOffsetX();
        setTimeout(function () {
            // this.tableLoading = false;
            _this.$emit('update:tableLoading', false);
            var hasMore = _this.searchParams.offset + _this.searchParams.limit > _this.total;
            _this.infiniteDisable = hasMore;
        }, 500);
    };
    // @Watch('tableHeight')
    // private heightChange(newVal: any) {
    //   console.log(newVal);
    // }
    Day.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log(2222222);
                return [2 /*return*/];
            });
        });
    };
    /* methods */
    Day.prototype.scrollToTop = function () {
        var table = this.$refs.table;
        if (table) {
            var tableBody = table.$tableRef.$refs.bodyWrapper;
            if (tableBody) {
                tableBody.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
            }
        }
    };
    Day.prototype.getTodayOffsetX = function () {
        var line = this.$refs.line;
        if (!line) {
            this.showHistoryLine = false;
            return;
        }
        var thDom = this.findParent(line, 'TH');
        if (!thDom) {
            this.showHistoryLine = false;
            return;
        }
        this.todayOffset = thDom.offsetLeft;
        this.showHistoryLine = true;
    };
    Day.prototype.findParent = function (node, type) {
        while (node) {
            var parentNode = node.parentNode;
            if (!parentNode || parentNode.nodeName === 'BODY')
                return null;
            if (parentNode.nodeName === type) {
                return parentNode;
            }
            node = parentNode;
        }
    };
    Day.prototype.scrollXHandle = function (x) {
        var line = this.$refs.line;
        if (line && x) {
            this.tableScrollX = x;
            if (this.todayOffset - x <= 80) {
                this.showHistoryLine = false;
            }
            else {
                this.showHistoryLine = true;
            }
        }
    };
    Day.prototype.arraySpanMethod = function (_a) {
        var row = _a.row, columnIndex = _a.columnIndex;
        if (!row.id) {
            if (columnIndex === 0) {
                var _b = this.searchParams, startDate = _b.startDate, endDate = _b.endDate;
                var daysDiff = dayjs(endDate).diff(dayjs(startDate), 'day');
                return this.dateType === 15 ? [1, 17] : [1, daysDiff + 2];
            }
            else {
                return [0, 0];
            }
        }
    };
    Day.prototype.headerCellClassName = function (_a) {
        var columnIndex = _a.columnIndex;
        if (!columnIndex)
            return '';
        if (columnIndex === this.hoverColumnIndex) {
            return 'column-hover';
        }
        return '';
    };
    Day.prototype.cellMouseEnter = function (_, __) {
        var index = dateFns.diffDayBetween(this.searchParams.startDate, __.label);
        this.hoverColumnIndex = index;
    };
    Day.prototype.cellMouseLeave = function () {
        this.hoverColumnIndex = 0;
    };
    Day.prototype.selectHandle = function (row, date, index, e) {
        var _this = this;
        var startAt = date;
        var endAt = date;
        var needReset = true;
        if (this.isSelecting && this.selected.sort === index) {
            if (startAt === this.selected.startAt) {
                return this.cancelSelected();
            }
            if (new Date(startAt) < new Date(this.selected.startAt)) {
                endAt = this.selected.endAt;
            }
            else {
                startAt = this.selected.startAt;
                needReset = false;
            }
            this.isSelecting = false;
        }
        else {
            this.isSelecting = true;
        }
        var selectedDates = collectDatesByStartAndEnd(startAt, endAt);
        var selected = {
            sort: index,
            boothInfo: __assign({}, row),
            dates: selectedDates,
            startAt: startAt,
            endAt: endAt,
        };
        return beforeSubmit(selected, function () {
            _this.setSelected(selected);
            needReset && _this.setAddClueDialog(e);
        }, function () {
            _this.$message.warning(dateFns.changeTime(startAt, '.', true) + "-" + dateFns.changeTime(endAt, '.', true) + "\u6863\u671F\u5DF2\u6EE1\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9");
            _this.cancelSelected();
        });
    };
    Day.prototype.setSelected = function (selected) {
        var sort = this.selected.sort;
        if (sort !== null) {
            this.calendars[sort].selectedDates = [];
        }
        this.selected = __assign({}, selected);
        var curSort = selected.sort;
        if (curSort !== null) {
            this.calendars[curSort].selectedDates = selected.dates;
        }
    };
    Day.prototype.tableScrollHandle = function () {
        var bodyDom = document.getElementsByClassName('el-table__body-wrapper')[0];
        var offset = bodyDom.scrollTop - this.curSelectLayout.scrollY;
        this.curSelectLayout.y = Math.min(Math.max(this.curSelectLayout.initY - offset, 60), bodyDom.clientHeight + 60 - 287);
    };
    Day.prototype.setAddClueDialog = function (e) {
        var table = this.$refs.tableWrap;
        var layout = getPopoverOffset(e, table.offsetTop, table.offsetLeft);
        var bodyDom = document.getElementsByClassName('el-table__body-wrapper')[0];
        this.curSelectLayout = __assign(__assign({}, layout), { scrollY: bodyDom.scrollTop, initY: layout.y });
        this.showAddClueDialog = true;
        if (bodyDom.scrollHeight > bodyDom.clientHeight) {
            bodyDom.addEventListener('scroll', this.tableScrollHandle); // 监听滚动事件
        }
    };
    Day.prototype.updateSelected = function (e) {
        if (e && e.length > 0) {
            var dates = collectDatesByStartAndEnd(new Date(e[0]), new Date(e[1]));
            this.selected.dates = dates;
            this.selected.startAt = e[0];
            this.selected.endAt = e[1];
            this.calendars[this.selected.sort].selectedDates = dates;
            this.isSelecting = false;
        }
    };
    Day.prototype.cancelSelected = function () {
        this.setSelected({
            sort: null,
            boothInfo: null,
            dates: [],
        });
        this.isSelecting = false;
        this.showAddClueDialog = false;
        var bodyDom = document.getElementsByClassName('el-table__body-wrapper')[0];
        bodyDom.removeEventListener('scroll', this.tableScrollHandle); // 注销滚动事件
    };
    Day.prototype.refreshHandle = function (item, index) {
        var sort = index || this.selected.sort;
        var startAt = item.startAt, endAt = item.endAt;
        var minDate = this.searchParams.startDate;
        var maxDate = this.searchParams.endDate;
        var minStamp = new Date(minDate).getTime();
        var maxStamp = new Date(maxDate).getTime();
        var startStamp = new Date(startAt).getTime();
        var endStamp = new Date(endAt).getTime();
        if (endStamp < minStamp || startStamp > maxStamp) {
            return this.cancelSelected();
        }
        var record = refactorSingleClueHandle(item, deepCopy(this.calendars[sort]));
        var refactorRecord = refactorCalendars({ records: [record], type: 'day', minDate: this.searchParams.startDate, maxDate: this.searchParams.endDate });
        this.calendars[sort] = refactorRecord.data[refactorRecord.data.length - 1];
        this.cancelSelected();
    };
    Day.prototype.loadCalendarData = function () {
        if (this.infiniteDisable)
            return;
        this.infiniteDisable = true;
        this.$emit('loadmore');
    };
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Day.prototype, "data", void 0);
    __decorate([
        Prop({ type: Object, default: function () { } })
    ], Day.prototype, "meta", void 0);
    __decorate([
        Prop({ type: Number, default: 0 })
    ], Day.prototype, "total", void 0);
    __decorate([
        Prop({ type: Object, default: function () { } })
    ], Day.prototype, "searchParams", void 0);
    __decorate([
        Prop({ type: Boolean, default: true })
    ], Day.prototype, "tableLoading", void 0);
    __decorate([
        Watch('data', {
            deep: true,
        })
    ], Day.prototype, "dataChange", null);
    Day = __decorate([
        Component({
            components: {
                Table: Table,
                DaySection: DaySection,
                DatePopover: DatePopover,
                BoothPopover: BoothPopover,
                HistoryLine: HistoryLine,
                AddClueDialog: AddClueDialog,
                Empty: Empty,
            },
            directives: {
                'el-table-infinite-scroll': ElTableInfiniteScroll,
            },
        })
    ], Day);
    return Day;
}(Vue));
export default Day;
